import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { adminDashboardActions } from '../slice';
import { selectCallSessions, selectChatSessions, selectError, selectIsLoading, selectLatestTimeLineItems } from '../slice/selectors';

type Params = {
  currentProduct: string | null | undefined;
};

export function useAdminDashboardSessions({ currentProduct }: Params) {
  const dispatch = useDispatch();
  const chatSessions = useSelector(selectChatSessions);
  const callSessions = useSelector(selectCallSessions);
  const latestTimeLineItems = useSelector(selectLatestTimeLineItems);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);
  const requestIfNeeded = React.useCallback(() => {
    if (!currentProduct) return;
    dispatch(adminDashboardActions.fetchDashboardSessionsRequested({ productId: currentProduct }));
  }, [currentProduct, dispatch]);

  const reload = React.useCallback(() => {
    if (!currentProduct ) return;
    dispatch(adminDashboardActions.fetchDashboardSessionsRequested({ productId: currentProduct, force: true }));
  }, [currentProduct, dispatch]);

  React.useEffect(() => {
    requestIfNeeded();
  }, [requestIfNeeded]);

  return {
    isLoading,
    error,
    chatSessions,
    callSessions,
    reload,
    latestTimeLineItems,
  };
}

